import { ScopeType, Selector } from 'src/common/types';
import DataStore from 'src/core/stores/data-store';
import FormStore from 'src/core/stores/form-store';
import { StructmasterUserRoleName, UpdateRoleItem } from './roles-store';
import { CommandResult } from 'src/core/stores/types';

export interface DefaultRolePermissionItem {
  permissionId: string;
  name: string;
  selector: Selector;
}

export interface DefaultRoleSummary {
  id: string;
  name: string;
  partnersOnly: boolean;
  selector: Selector;
  permissions: DefaultRolePermissionItem[];
  addToScopeTypeCreator?: ScopeType;
}

export interface DefaultRoleItem {
  id: string;
  name: string;
  partnersOnly: boolean;
  selector: Selector;
  permissions: DefaultRolePermissionItem[];
  addToScopeTypeCreator?: ScopeType;
}

export interface CreateDefaultRoleItem {
  name: string;
  selector: Selector;
  partnersOnly: boolean;
  permissions?: string[];
  addToScopeTypeCreator?: ScopeType;
}

export interface UpdateDefaultRoleItem {
  name: string;
  selector: Selector;
  partnersOnly: boolean;
  permissions?: string[];
  addToScopeTypeCreator?: ScopeType;
}

const lockedRoles = [StructmasterUserRoleName];

export const roleIsLocked = (roleName: string) => {
  return lockedRoles.includes(roleName);
};

export class DefaultRoleSummaryStore extends DataStore<DefaultRoleSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/default-roles`, []);
  }
}

export class DefaultRoleItemStore extends FormStore<DefaultRoleItem, CreateDefaultRoleItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/default-roles`);
  }

  public async update(id: string, item: UpdateRoleItem) {
    return await this.handleCallAsync(async () => {
      try {
        var result = await this.httpService.put<UpdateRoleItem, CommandResult<UpdateRoleItem>>(`${this.baseUrl}/${encodeURIComponent(id)}`, item);
        return result.data;
      } catch {
        return { isSuccess: false };
      }
    });
  }

  public async loadRole(id: string) {
    return await this.handleCallAsync(async () => {
      var response = await this.httpService.get<DefaultRoleItem>(`${this.baseUrl}/${encodeURIComponent(id)}`);
      this._state.set((s) => {
        s.item = response.data as DefaultRoleItem;
        return s;
      });
      return response.data as DefaultRoleItem;
    });
  }

  rolePermissionsBasePath = 'permissions';

  public async addRolePermissions(id: string, permissionIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.post(`${this.baseUrl}/${encodeURIComponent(id)}/${this.rolePermissionsBasePath}`, {
        permissions: permissionIds,
      });
      return result.data;
    });
  }

  public async deleteRolePermissions(id: string, permissionIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.delete(`${this.baseUrl}/${encodeURIComponent(id)}/${this.rolePermissionsBasePath}`, {
        permissions: permissionIds,
      });
      return result.data;
    });
  }
}
